<div
  class="avatar avatar--medium"
  [class.avatar--empty]="!user()?.personalData?.avatar"
  aria-hidden="true"
>
  <img
    *ngIf="user()?.personalData?.avatar"
    [src]="user()?.personalData?.avatar"
    [alt]="'app.headerV2.avatar' | translate"
  />
  <span *ngIf="!user()?.personalData?.avatar" class="avatar__initials">
    {{ user()?.personalData | initials }}
  </span>
</div>

